(function(root){
  var lastJson = null;
  var applying = false;
  var maxAttempts = 40;
  var attempt = 0;

  function domReady(cb){
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      cb();
    } else {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
    }
  }

  function ensureJQuery(cb){
    if (root.jQuery) { cb(root.jQuery); return; }
    if (attempt >= maxAttempts) { warn('jQuery not found; giving up.'); return; }
    attempt++;
    setTimeout(function(){ ensureJQuery(cb); }, 200);
  }

  function log(){ if (root.console && console.debug) console.debug.apply(console, ['MenuAdornments:'].concat([].slice.call(arguments))); }
  function warn(){ if (root.console && console.warn) console.warn.apply(console, ['MenuAdornments:'].concat([].slice.call(arguments))); }

  function setup(json){
    if (!json) { warn('setup called with empty json'); return; }
    lastJson = json;
    scheduleApply();
  }

  function scheduleApply(){
    if (applying) return;
    applying = true;
    ensureJQuery(function($){
      domReady(function(){
        try { applyNow($); }
        finally { applying = false; }
      });
    });
  }

  function applyNow($){
    if (!lastJson) { return; }
    var adornments_hash;
    try {
      adornments_hash = JSON.parse(lastJson);
    } catch(e) {
      warn('Invalid JSON passed to setup:', e);
      return;
    }
    for (var path in adornments_hash) {
      if (!Object.prototype.hasOwnProperty.call(adornments_hash, path)) continue;
      var adornment_data = adornments_hash[path];
      var menu_item = $('*[data-menu-path="' + path + '"] a');
      adorn_item(menu_item, adornment_data, $);
    }
    log('applied adornments', Object.keys(adornments_hash));
  }

  function adorn_item(node, data, $){
    if (!node || node.length === 0) return;
    if (data.css_class) node.addClass(data.css_class);
    node.attr('data-before-content', data.before_content);
    node.attr('data-after-content', data.after_content);
    if (data.style) { node.css(data.style); }
  }

  document.addEventListener('turbo:load', function(){ if (lastJson) scheduleApply(); });

  if (!root.MenuAdornments) {
    root.MenuAdornments = { setup: setup };
  } else if (root.MenuAdornments._queued) {
    var queued = root.MenuAdornments._queued.slice();
    root.MenuAdornments.setup = setup;
    delete root.MenuAdornments._queued;
    queued.forEach(function(json){ setup(json); });
  } else if (!root.MenuAdornments.setup) {
    root.MenuAdornments.setup = setup;
  } else {
    var original = root.MenuAdornments.setup;
    root.MenuAdornments.setup = function(json){ lastJson = json; original(json); };
  }
})(window);
